import { useState } from "react";

import CancellationFlow from "features/subscriptions/components/CancellationFlow";

import { Dialog, DialogContent } from "common/components/ui/Dialog";
import { Drawer, DrawerContent } from "common/components/ui/Drawer";
import useTwBreakpoint from "common/hooks/useTwBreakpoint";

type CancelStep = "confirm" | "feedback";

interface CancelSubscriptionDialogProps {
  subscriptionId: string;
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  shouldShowSurvey: boolean;
  onCancellationSuccess: () => void;
  avatarCount?: number;
}

export default function CancelSubscriptionDialog({
  subscriptionId,
  isOpen,
  setIsOpen,
  shouldShowSurvey,
  onCancellationSuccess,
  avatarCount,
}: CancelSubscriptionDialogProps) {
  const [size, setSize] = useState<"md" | "lg">("md");
  const [resetKey, setResetKey] = useState(0);
  const isDesktop = useTwBreakpoint("md");

  const Component = isDesktop ? Dialog : Drawer;
  const Content = isDesktop ? DialogContent : DrawerContent;

  function handleSubStepChange(step: CancelStep) {
    setSize(step === "feedback" ? "lg" : "md");
  }

  function handleAfterClose() {
    setSize("md");
    setResetKey((k) => k + 1);
  }

  return (
    <Component
      open={isOpen}
      onOpenChange={setIsOpen}
      onAfterClose={handleAfterClose}
    >
      <Content size={size}>
        <CancellationFlow
          key={resetKey}
          subscriptionId={subscriptionId}
          mode={shouldShowSurvey ? "default" : "skipSurvey"}
          avatarCount={avatarCount}
          onCancellationSuccess={() => {
            onCancellationSuccess();
            setIsOpen(false);
          }}
          goBack={() => setIsOpen(false)}
          onSubStepChange={handleSubStepChange}
        />
      </Content>
    </Component>
  );
}
